import { render, staticRenderFns } from "./SpectMiocardicaViewComponent.vue?vue&type=template&id=73c14658"
import script from "./SpectMiocardicaViewComponent.vue?vue&type=script&lang=js"
export * from "./SpectMiocardicaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports